import script from "./MessageItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./MessageItem.vue?vue&type=script&setup=true&lang=ts"

import "./MessageItem.vue?vue&type=style&index=0&id=9f2beb1e&lang=scss"

const __exports__ = script;

export default __exports__